import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
const RangeSlider = ({ name, value = [0, 99999], onChange, ele,  filterBtnsSelected}) => {
  const [min, setMin] = useState(value[0]);
  const [max, setMax] = useState(value[1]);

  useEffect(() => {
    let [obj] = filterBtnsSelected[ele.name];
    if(Array.from(filterBtnsSelected[ele.name]).length==0) {
      setMin(0);
      setMax(99999);
    } else if ((!(obj instanceof Set)) && (!(obj instanceof Object))) {
      let [min, max] = filterBtnsSelected[ele.name];
      setMin(min);
      setMax(max);
    } else {
      setMin(Array.from(filterBtnsSelected[ele.name])[0]['greaterThan']);
      setMax(Array.from(filterBtnsSelected[ele.name])[0]['lesserThan']);
    }
  }, [filterBtnsSelected]);

  const handleMinChange = (e) => {
    const raw = e.target.value;
    const num = raw === "" ? 0 : parseInt(raw);
    setMin(num);
    onChange?.([num, max]);
  };

  const handleMaxChange = (e) => {
    const raw = e.target.value;
    const num = raw === "" ? 0 : parseInt(raw);
    setMax(num);
    onChange?.([min, num]);
  };

  const rangeInputControls = () => (
    <div className="d-flex align-items-center gap-2">
      <Form.Control
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={min}
        placeholder="Min"
        onChange={handleMinChange}
        onFocus={() => min === 0 && setMin("")}
        className="p-0 shadow-none"
        style={{
          width: "60px",
          height: "35px",
          fontSize: "0.875rem",
          fontWeight: "500",
          color: "#316CF4",
          backgroundColor: "transparent",
          borderTop: "0",
          borderLeft: "0",
          borderRight: "0",
          borderBottom: "1px solid #ced4da",
          borderRadius: "0",
        }}
      />
      <span style={{ color: "#6c757d" }}>-</span>
      <Form.Control
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={max}
        placeholder="Max"
        onChange={handleMaxChange}
        onFocus={() => max === 99999 && setMax("")}
        className="p-0 shadow-none"
        style={{
          width: "60px",
          height: "35px",
          fontSize: "0.875rem",
          fontWeight: "500",
          color: "#316CF4",
          backgroundColor: "transparent",
          borderTop: "0",
          borderLeft: "0",
          borderRight: "0",
          borderBottom: "1px solid #ced4da",
          borderRadius: "0",
        }}
      />
    </div>
  );
  
  return (
    name === "rating_count" ? (
      <div
        key="rating-count-slider"
        className="rating-count-label-filter-name selected"
        style={{ marginTop: "-5px" }}
      >
        <div
          className="name-top"
          title="Rating Count Range"
          style={{
            fontSize: "12px",
            fontFamily: "Lato, sans-serif",
            color: "#212529",
            padding: "7px 5px 0px",
          }}
        >
          Review Count
        </div>
        {rangeInputControls()}
      </div>
    ) : (
      <>
        <div
          key="price-slider"
          className="price-range-label-filter-name selected"
          style={{ marginTop: "-5px" }}
        >
          <div
            className="name-top"
            title="Price Range"
            style={{
              fontSize: "12px",
              fontFamily: "Lato, sans-serif",
              color: "#212529",
              padding: "7px 5px 0px",
            }}
          >
            <div className="d-flex align-items-center">
              <span>Price Range</span>
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="brand-depth-tooltip">
                    Filtering by Price Range is driven by the selected Price Type.
                  </Tooltip>
                }
              >
                <span
                  className="text-muted cursor-help"
                  style={{ marginLeft: "6px", lineHeight: 0 }}
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                </span>
              </OverlayTrigger>
            </div>
          </div>
          {rangeInputControls()}
        </div>
      </>
    )
  );
};

export default RangeSlider;